'use strict';

import React from 'react';
import { FocusTrap } from '@americanexpress/aqx-components';
import textRemoveTags from 'service_modules/utils/text-remove-tags';

const modalEleId = 'amazon-redirect-modal';
export default class AexpAmazonRedirectModal extends React.Component {
  componentDidMount() {
    document.getElementsByTagName('body')[0].classList.add('modal-open');

    setTimeout(() => {
      const wrapEle = document.getElementById(modalEleId);
      const eleList = wrapEle.querySelectorAll('a, button');
      if (eleList && eleList.length > 0) {
        eleList[eleList.length - 1].focus();
      }
    }, 800);
  }

  componentWillUnmount() {
    document.getElementsByTagName('body')[0].classList.remove('modal-open');
  }

  render() {
    const {
      title = 'Title',
      message = 'Message',
      buttonClick = () => {},
      cancelClick = () => {},
      buttonText = 'Button',
      url,
      className
    } = this.props;

    return (
      <aexp-amazon-redirect-modal id={modalEleId} class={className}>
        <FocusTrap useAriaModal={true}>
          <div className="modal-box">
            <div
              className="title"
              role="alert"
              aria-label={`${textRemoveTags(title)} ${textRemoveTags(message)}`}
              dangerouslySetInnerHTML={{ __html: title }}
            />
            <div className="message">{message}</div>
            <div className="modalButtonContainer">
              <button
                className=" cancelButton apply-button aexp-button button"
                onClick={cancelClick}
              >
                Cancel
              </button>
              <a tabIndex="-1" href={url}>
                <button
                  className=" redirectButton apply-button aexp-button aexp-button--blue button"
                  onClick={buttonClick}
                >
                  {buttonText}
                </button>
              </a>
            </div>
          </div>
        </FocusTrap>
      </aexp-amazon-redirect-modal>
    );
  }
}
